/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

export interface WCAvatar {
  id: string;
  name: string;
  icon: string;
  bgClass: string;
  textColor: string;
  sub: string;
}

export const WC_AVATARS: WCAvatar[] = [
  {
    id: "wc_trophy",
    name: "World Cup Trophy",
    icon: "🏆",
    bgClass: "bg-gradient-to-br from-amber-400 via-yellow-500 to-amber-700",
    textColor: "text-amber-950",
    sub: "FIFA Gold"
  },
  {
    id: "wc_ball",
    name: "2026 Match Ball",
    icon: "⚽",
    bgClass: "bg-gradient-to-br from-slate-100 via-slate-300 to-slate-500",
    textColor: "text-slate-900",
    sub: "Official Speed"
  },
  {
    id: "wc_metlife",
    name: "MetLife Champion",
    icon: "🏟️",
    bgClass: "bg-gradient-to-br from-blue-600 via-indigo-600 to-blue-900",
    textColor: "text-blue-100",
    sub: "NY/NJ Final"
  },
  {
    id: "wc_azteca",
    name: "Azteca Legend",
    icon: "🇲🇽",
    bgClass: "bg-gradient-to-br from-emerald-600 via-green-600 to-red-600",
    textColor: "text-white",
    sub: "CDMX Icon"
  },
  {
    id: "wc_maple",
    name: "Maple Striker",
    icon: "🇨🇦",
    bgClass: "bg-gradient-to-br from-red-600 via-red-500 to-rose-800",
    textColor: "text-white",
    sub: "Vancouver BC"
  },
  {
    id: "wc_stars",
    name: "Stars & Stripes",
    icon: "🇺🇸",
    bgClass: "bg-gradient-to-br from-blue-800 via-indigo-900 to-red-600",
    textColor: "text-white",
    sub: "USA Host"
  },
  {
    id: "wc_boot",
    name: "Golden Boot",
    icon: "👟",
    bgClass: "bg-gradient-to-br from-yellow-400 via-amber-500 to-yellow-600",
    textColor: "text-amber-950",
    sub: "Top Scorer"
  },
  {
    id: "wc_glove",
    name: "Golden Glove",
    icon: "🧤",
    bgClass: "bg-gradient-to-br from-orange-400 via-amber-500 to-orange-600",
    textColor: "text-orange-950",
    sub: "Clean Sheet"
  },
  {
    id: "wc_coach",
    name: "Master Tactician",
    icon: "👔",
    bgClass: "bg-gradient-to-br from-slate-700 via-slate-800 to-slate-950",
    textColor: "text-slate-200",
    sub: "Manager"
  },
  {
    id: "wc_refree",
    name: "Card Decider",
    icon: "🟥",
    bgClass: "bg-gradient-to-br from-red-500 via-rose-600 to-red-750",
    textColor: "text-white",
    sub: "VAR Approved"
  },
  {
    id: "wc_crown",
    name: "Paganini Master",
    icon: "👑",
    bgClass: "bg-gradient-to-br from-purple-600 via-fuchsia-600 to-indigo-800",
    textColor: "text-purple-100",
    sub: "100% Collector"
  },
  {
    id: "wc_mascot",
    name: "Tournament Mascot",
    icon: "🦁",
    bgClass: "bg-gradient-to-br from-amber-500 to-orange-500",
    textColor: "text-amber-950",
    sub: "2026 Cheer"
  }
];

export const getAvatarById = (id: string | null | undefined): WCAvatar | undefined => {
  if (!id) return undefined;
  return WC_AVATARS.find(av => av.id === id);
};

export const isCustomWCAvatar = (id: string | null | undefined): boolean => {
  if (!id || typeof id !== 'string') return false;
  return id.startsWith("wc_");
};
